<template>
    <div id="manage-config">
        <div class="vx-card p-4">
            <div class="vx-row">
                <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full sm:mt-0 mt-2">
                    <label class="vs-input--label">{{ $t('managementConfiguration.selectManager') }}</label>
                    <v-select class="w-full" :clearable="false" :options="dataEmployee" @input="search"
                              :reduce="options => options.value" v-model="selectManager">
                    </v-select>
                </div>
                <div class="vx-col lg:w-1/2 w-1/2">
                    <vs-button class="mt-6 sm:float-left float-right" color="primary" iconPack="feather"
                               icon="icon-plus" @click="openPopup">
                        {{ this.$t('menuNewFeed.create') }}
                    </vs-button>
                </div>
            </div>
        </div>
        <VuePerfectScrollbar ref="scrollBar" @ps-scroll-y="handleScroll"
                             class="scroll-area--nofications-dropdown p-0 mt-8 vx-card" :settings="settings"
                             :key="$vs.rtl">
            <div class="px-4 pb-4 mt-6 vx-row match-height">
                <div class="vx-col lg:w-1/5 md:w-1/4 sm:w-1/2 w-full mt-4" v-for="(data, ind) in dataGroup" :key="ind">
                    <div class="user-card">
                        <div class="header py-2 flex justify-center">
                            <!--                            <span class="font-semibold text-primary text-center groupName">{{ data.groupName }}</span>-->
                            <vs-dropdown vs-trigger-click class="cursor-pointer">
                                <!--                                <small class="flex cursor-pointer mr-4">-->
                                <span class="font-semibold text-lg text-primary text-center groupName">{{
                                        data.groupName
                                    }}</span>
                                <!--                                </small>-->
                                <vs-dropdown-menu class="w-32">
                                    <vs-dropdown-item @click="updateGr(data.id, data)">
                                        <div class="flex items-center py-2 gap-2">
                                            <feather-icon svg-classes="h-4 w-4" icon="EyeIcon"
                                                          color="primary"></feather-icon>
                                            <h6>Chi tiết</h6>
                                        </div>
                                    </vs-dropdown-item>
                                    <vs-dropdown-item @click="popupDelete(data)">
                                        <div class="flex items-center py-2 gap-2">
                                            <feather-icon svg-classes="h-4 w-4" icon="Trash2Icon"
                                                          color="danger"></feather-icon>
                                            <h6>Xóa</h6>
                                        </div>
                                    </vs-dropdown-item>
                                </vs-dropdown-menu>
                            </vs-dropdown>

                        </div>
                        <div class="flex items-center justify-center my-2">
                            <feather-icon icon="AwardIcon" class="icon"
                                          svgClasses="h-5 w-5 hover:text-danger cursor-pointer"/>
                            <p class="text-primary">{{ data.responsibleEmployee.fullName }}</p>
                        </div>
                        <div v-for="(epl, index) in data.employeeGroupList" :key="index"
                             class="flex items-center justify-center">
                            {{ epl.fullName }}
                        </div>
                    </div>
                </div>
            </div>
        </VuePerfectScrollbar>
        <vs-popup :title="isUpdate ? 'Cập nhật nhóm' : 'Tạo mới nhóm'" :active.sync="popupActiveUse">
            <div class="vx-row">
                <div class="vx-col w-full">
                    <label class="vs-input--label">{{ $t('managementConfiguration.groupName') }}</label>
                    <span class="text-danger text-sm">*</span>
                    <vs-input class="md:w-full " v-model="groupName"/>
                </div>
                <div class="vx-col w-full mt-2">
                    <label class="vs-input--label">{{ $t('managementConfiguration.selectManager') }}</label>
                    <span class="text-danger text-sm">*</span>
                    <v-select class="w-full" :clearable="false" :options="dataEmployee" v-model="manager"
                              :reduce="options => options.value" @input="changData(manager)">
                    </v-select>
                </div>
                <div class="vx-col w-full mt-2">
                    <label class="vs-input--label">{{ $t('managementConfiguration.selectEmployee') }}</label>
                    <span class="text-danger text-sm">*</span>
                    <!--                    <v-select class="w-full" :clearable="false" :options="optionEmployee" v-model="employeeIds"-->
                    <!--                              :reduce="options => options.value" multiple>-->
                    <!--                    </v-select>-->
                    <multiselect
                        name="student"
                        data-vv-validate-on="input"
                        v-model="employeeIds"
                        :options="optionEmployee"
                        group-values="libs"
                        group-label="all"
                        :group-select="true"
                        :multiple="true"
                        :close-on-select="false"
                        placeholder=""
                        label="label"
                        track-by="value"
                        selectedLabel="Đã chọn"
                        selectGroupLabel=""
                        deselectGroupLabel=""
                        deselectLabel=""
                        selectLabel=""
                        v-validate="'required'"
                    >
                        <template #noResult>
                            <span>{{ $t('managementConfiguration.noDataMatching') }}</span>
                        </template>
                        <template #noOptions>
                            <span>{{ $t('managementConfiguration.noData') }}</span>
                        </template>
                    </multiselect>
                </div>
            </div>
            <div class="vx-row">
                <div class="vx-col w-full">
                    <div class="mt-4 flex flex-wrap items-center justify-end">
                        <vs-button @click="updateGroup" v-if="isUpdate">{{
                                $t('managementConfiguration.update')
                            }}
                        </vs-button>
                        <vs-button @click="createAgroup" v-else>{{
                                $t('managementConfiguration.addGroup')
                            }}
                        </vs-button>
                    </div>
                </div>
            </div>
        </vs-popup>
    </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import vSelect from 'vue-select';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import Multiselect from 'vue-multiselect'

export default {
    components: {
        vSelect,
        VuePerfectScrollbar,
        Multiselect,
    },
    data() {
        return {
            popupActiveUse: false,
            dataEmployee: [],
            groupName: null,
            employeeIds: [],
            selectManager: null,
            manager: null,
            organizationId: null,
            dataGroup: [],
            ids: null,
            isUpdate: false,
            groupId: null,
            optionEmployee: [
                {
                    all: 'Tất cả',
                    libs: []
                }
            ],
            settings: {
                maxScrollbarLength: 30,
                wheelSpeed: .60,
            },
            data: [],
        }
    },
    created() {
        let userInfo = this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
        this.organizationId = userInfo.organization.id
        this.getGroup()
        this.getEmployee()
    },
    methods: {
        changData(manager) {
            this.optionEmployee[0].libs = this.dataEmployee.filter(el => el.value !== manager)
            this.employeeIds = []
        },
        openPopup() {
            this.isUpdate = false
            this.groupName = null
            this.manager = null
            this.employeeIds = []
            this.popupActiveUse = true
        },
        search() {
            this.getGroup();
        },
        updateGr(id, data) {
            this.groupId = id
            this.isUpdate = true
            this.popupActiveUse = true
            if (id) {
                this.groupName = data.groupName
                this.manager = data.responsibleEmployee.id
                this.employeeIds = data.employeeGroupList.map(e => {
                    return {
                        label: e.fullName,
                        value: e.employeeId,
                    }
                })
                this.optionEmployee[0].libs = this.dataEmployee.filter(el => el.value !== this.manager)
            }
        },
        popupDelete(data) {
            this.ids = data.id
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận xóa`,
                text: `Bạn có chắc là muốn xóa bỏ nhóm "${data.groupName}"?`,
                accept: this.deleteGroup,
                acceptText: this.$t('button.agree'),
                cancelText: this.$t('button.cancel')
            })
        },
        createAgroup(evt) {
            if (this.groupName === null || this.manager == null || this.employeeIds.length < 1) {
                return this.$vs.notify({
                    text: 'Vui lòng nhập đầy đủ thông tin!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });

            }
            let payload = {
                groupName: this.groupName,
                responsibleEmployeeId: this.manager,
                employeeIds: this.employeeIds.map(el => el.value),
                type: 1,
            }
            this.$vs.loading();
            this.$crm.post(`employee-group/create`, payload).then((res) => {
                this.popupActiveUse = false
                this.$vs.loading.close();
                this.$vs.notify({
                    text: 'Tạo mới thành công!',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                });
                this.getGroup();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Error',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        deleteGroup() {
            this.$vs.loading();
            this.$crm.post(`employee-group/delete/${this.ids}`).then((res) => {
                this.$vs.loading.close();
                this.$vs.notify({
                    text: 'Xóa thành công!',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                });
                this.getGroup()
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Error',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        updateGroup() {
            let payload = {
                groupName: this.groupName,
                responsibleEmployeeId: this.manager,
                employeeIds: this.employeeIds.map(el => el.value),
                type: 1,
            }
            this.$vs.loading();
            this.$crm.post(`employee-group/update/${this.groupId}`, payload).then((res) => {
                this.$vs.loading.close();
                this.popupActiveUse = false;
                this.$vs.notify({
                    text: 'Cập nhật thành công!',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                });
                this.getGroup()
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Error',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        getEmployee() {
            this.$vs.loading();
            let body = {
                permissions: ['PRIVILEGE_VBOT_CUSTOMER_CALL'],
                organizationId: this.organizationId
            }
            this.$crm.post(`/employee/get-employees-by-permissions`, body).then((res) => {
                this.dataEmployee = res.data.map(e => {
                    return {
                        label: e.fullName,
                        value: e.employeeId,
                    }
                })
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Error',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        getGroup() {
            this.$vs.loading();
            let body = {
                responsibleEmployeeId: this.selectManager,
                page: 0,
                size: 20,
            }
            this.$crm.post(`employee-group/find-by-condition`, body).then((res) => {
                this.dataGroup = res.data.content
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Error',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        handleScroll(evt) {
            const {scrollTop, offsetHeight, scrollHeight} = evt.target
            if (((scrollTop + offsetHeight) >= scrollHeight)) {
            }
        }
    },
    computed: {
        validateForm() {
            return !this.errors.any()
        },
    },

}
</script>
<style scoped lang="scss">

.user-card {
    border: 1px solid #ccc;
    border-radius: 5px;
    width: 100%;
}

.header {
    border-bottom: 1px solid #ccc;
    background-color: rgb(242, 238, 244);

    .groupName {
        width: 100%;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
}
</style>

<style lang="scss">
#manage-config {
    //.multiselect__tags {
    //    max-height: 100px !important;
    //
    //    .multiselect__tags-wrap {
    //        max-height: 90px !important;
    //        overflow-y: auto;
    //        display: block;
    //    }
    //}
    //
    //.multiselect__content-wrapper {
    //    z-index: 500 !important;
    //    box-shadow: rgba(0, 0, 0, 0.07) 0px 1px 1px, rgba(0, 0, 0, 0.07) 0px 2px 2px, rgba(0, 0, 0, 0.07) 0px 4px 4px, rgba(0, 0, 0, 0.07) 0px 8px 8px, rgba(0, 0, 0, 0.07) 0px 16px 16px;
    //}
}
</style>
